var map = {
  "./applications.json": "48746",
  "./apps.json": "31677",
  "./attachment_relations.json": "91078",
  "./boarding.json": "66861",
  "./calendar.json": "86427",
  "./common.json": "47600",
  "./customizable_table.json": "2834",
  "./dashboard.json": "9855",
  "./job_ads.json": "85733",
  "./layouts.json": "72688",
  "./mailer.json": "77937",
  "./modules.json": "83234",
  "./news.json": "8438",
  "./payments.json": "94934",
  "./permission_presets.json": "961",
  "./posting_orders.json": "26132",
  "./search.json": "24513",
  "./skills.json": "88635",
  "./statistics.json": "2722",
  "./support.json": "48348",
  "./time_tracking.json": "51924",
  "./wizard_settings.json": "80474"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 32436;
